//import "@babel/polyfill";
class dataServices {
    constructor() {
      this.baseAddress = "/modService/api/";
    }
    getSPListItems(siteUrl, listName, viewName) {
      let reqItems = {
        webUrl: siteUrl,
        listName: listName,
        viewName: viewName,
        showAttach: "true",
        showLookupChild: true,
      };
      listName = encodeURIComponent(listName);
      viewName = encodeURIComponent(viewName);
      let address = `${this.baseAddress}Items`;
      return axios.post(address, reqItems);
    }
    getSPListItemsForce(siteUrl, listName, viewName) {
      let reqItems = {
        webUrl: siteUrl,
        listName: listName,
        viewName: viewName,
        showAttach: "true",
        showLookupChild: true,
      };
      listName = encodeURIComponent(listName);
      viewName = encodeURIComponent(viewName);
      let address = `${this.baseAddress}ItemsForce`;
      return axios.post(address, reqItems);
    }
  
    setItems(data) {
   //   debugger;
      let address = `${this.baseAddress}NewItem`;
      return axios.post(address, data);
    }
  }
  
  export default new dataServices(); 
  